import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'brisbaneDate',
  standalone: true,
})
export class BrisbaneDatePipe implements PipeTransform {
  private datePipe = new DatePipe('en-AU');

  // Brisbane is UTC+10 (no daylight saving)
  private readonly BRISBANE_OFFSET = '+1000';

  transform(value: string | Date | null | undefined, format: string = 'dd/MM/yyyy'): string {
    if (!value) return '-';
    // Ensure string dates without a timezone marker are treated as UTC
    // so the +1000 offset is applied correctly regardless of browser timezone
    const normalized =
      typeof value === 'string' && !value.endsWith('Z') && !value.includes('+')
        ? value + 'Z'
        : value;
    return this.datePipe.transform(normalized, format, this.BRISBANE_OFFSET) ?? '-';
  }
}
